/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $UserComplianceRequest = {
  properties: {
    answers: {
      properties: {
      },
      isRequired: true,
    },
    userId: {
      type: 'string',
      isRequired: true,
    },
  },
} as const;
